import {Injectable} from "@angular/core";
import {APIProxy, HttpObservable} from "../../http/services";
import {HijriDate} from "./hijri.date.service";


@Injectable({ providedIn: 'root' })
  export class HijriDateProxy {

	constructor(private http: APIProxy) {
	}

	public getHijriDate(date: Date): HttpObservable<HijriDate>{
		return this.http.get("HijriDate","GetDate",[
			{pName: "date", pVal: date}
		]);
	}

	public getHijriDatesInDecade(year: number): HttpObservable<HijriDate[]> {
		return this.http.get("HijriDate", "GetHijriDatesInDecade", [
			{pName: "year", pVal: year}
		]);
	}


	public getHijriDatesInYear(year: number):HttpObservable<HijriDate[]>{
		return this.http.get("HijriDate","GetHijriDatesInYear",[
			{pName: "year", pVal: year}
		]);
	}

	public getHijriDatesInMonth(date1: Date, date2:Date): HttpObservable<HijriDate[]>{
		return this.http.get("HijriDate","GetHijriDatesInMonth",[
			{pName: "date1", pVal: date1},
			{pName: "date2", pVal: date2}
		]);
	}

	public getAllHijriDates(startDate: Date, endDate:Date): HttpObservable<HijriDate[]>{
		return this.http.get("HijriDate","GetAllHijriDates",[
			{pName: "startDate", pVal: startDate},
			{pName: "endDate", pVal: endDate}
		]);
	}
}
